/** Post types exposed on the public website (app-only types excluded). */
export const WEB_POST_TYPES = ['Article', 'Business', 'Event', 'Marketplace']

export const WEB_BASE_URL = 'https://imigo.app'

export const POST_TYPE_ROUTE_MAP = {
  Article: 'articles',
  Business: 'businesses',
  Event: 'events',
  Marketplace: 'marketplace',
  Forum: 'forum',
  Activity: 'activities',
  product: 'products',
}

export const getPostTypeRoute = (postType) => {
  if (!postType) return 'articles'

  const name = resolvePostTypeName(postType)
  return POST_TYPE_ROUTE_MAP[name] || `${name.toLowerCase()}s`
}

/** Resolve post type name from API shapes or URL segment fallback. */
export const resolvePostTypeName = (postType, routeSegment) => {
  if (!postType && routeSegment) {
    const fromRoute = {
      articles: 'Article',
      article: 'Article',
      businesses: 'Business',
      business: 'Business',
      events: 'Event',
      event: 'Event',
      marketplace: 'Marketplace',
    }
    return fromRoute[routeSegment?.toLowerCase()] || 'Article'
  }

  if (typeof postType === 'string') return postType

  return (
    postType?.data?.attributes?.name ||
    postType?.attributes?.name ||
    postType?.name ||
    'Article'
  )
}

export const inferRouteSegmentFromPath = (pathname) => {
  const match = pathname.match(/\/(articles|businesses|events|event|marketplace|article|business)\//i)
  return match ? match[1].toLowerCase() : null
}

export const isIranianNationality = (nationality) => {
  if (!nationality) return false
  const data = nationality.data?.attributes || nationality.attributes || nationality
  const id = nationality.data?.id || nationality.id
  if (id === 1) return true
  const lang = String(data.language_query || '').toLowerCase()
  if (lang === 'fa' || lang === 'fa-ir') return true
  const label = String(data.Nationality || data.language || '').toLowerCase()
  return label.includes('iran') || label.includes('persian') || label.includes('farsi')
}

export const getNationalityFontClass = (nationality) => {
  if (isIranianNationality(nationality)) return 'font-fa'
  if (nationality?.data?.attributes?.language_query === 'ar') return 'font-ar'
  return ''
}

export const resolveCreator = (creator) => {
  if (!creator) {
    return { id: null, name: 'Imigo', picture: null }
  }

  if (creator.name || creator.id) {
    const picture =
      typeof creator.picture === 'string'
        ? creator.picture.startsWith('http')
          ? creator.picture
          : `https://panel.imigo.app${creator.picture}`
        : creator.picture?.data?.attributes?.formats?.thumbnail?.url
          ? `https://panel.imigo.app${creator.picture.data.attributes.formats.thumbnail.url}`
          : null

    return {
      id: creator.id || null,
      name: creator.name || 'Imigo',
      picture,
    }
  }

  const data = creator.data?.attributes || creator.attributes
  const id = creator.data?.id || creator.id || null

  return {
    id,
    name: data?.name || 'Imigo',
    picture: data?.picture?.data?.attributes?.formats?.thumbnail?.url
      ? `https://panel.imigo.app${data.picture.data.attributes.formats.thumbnail.url}`
      : null,
  }
}

export const hasCreator = (post) => {
  const creator = post?.attributes?.creator
  if (!creator) return false
  return Boolean(creator.id || creator.data?.id || creator.data?.attributes?.id)
}
